import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { bestTimes: { getBestTimes } } = apiUrls;

export const GET_BEST_TIMES_REPORT_SUCCESS = 'GET_BEST_TIMES_REPORT_SUCCESS';
export const GET_BEST_TIMES_REPORT_LOADING = 'GET_BEST_TIMES_REPORT_LOADING';
export const GET_SHOPIFY_BEST_TIMES_REPORT_SUCCESS = 'GET_SHOPIFY_BEST_TIMES_REPORT_SUCCESS';
export const GET_SHOPIFY_BEST_TIMES_REPORT_LOADING = 'GET_SHOPIFY_BEST_TIMES_REPORT_LOADING';
export const GET_WHOLESALE_BEST_TIMES_REPORT_SUCCESS = 'GET_WHOLESALE_BEST_TIMES_REPORT_SUCCESS';
export const GET_WHOLESALE_BEST_TIMES_REPORT_LOADING = 'GET_WHOLESALE_BEST_TIMES_REPORT_LOADING';

export const getBestTimesReportData = ({ fromDate, toDate, salesChannel, vendor }) => async (dispatch) => {
    const apiData = getBestTimes;

    try {
        const { url } = apiData;

        if (vendor) {
            const requestData = {
                ...apiData,
                url: url.replace('{{vendor}}', vendor),
                data: {
                    fromDate, toDate, salesChannel
                }
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: GET_BEST_TIMES_REPORT_SUCCESS,
                data,
                vendor
            })
        }

    } catch (e) {

        dispatch({
            type: GET_BEST_TIMES_REPORT_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            },
            vendor
        })
    }

}



export const handleLoader = (isLoading, vendor) => (dispatch) => {

    if (vendor) {
        dispatch({
            type: GET_BEST_TIMES_REPORT_LOADING,
            isLoading,
            vendor
        })
    }
}
